// >>> HER CORRECTION (2026-08-19) — ONE DOOR, HERS, OR NO DOOR AT ALL. <<<
//
// HER WORDS: *"My Room shows ONLY the reading(s) with a real claim on that member: the funnel/
// home-card reading they actually clicked to arrive... rendered as its beautiful door in their room,
// gated at the tap per FREE-1. No roster, no crowd, nothing unclicked."*
//
// >>> THIS REPLACES BOTH RETIRED SURFACES, AND THE FILE IS RENAMED BECAUSE THE THING IS SINGULAR.
// <<< `MyRoomReadingDoors.tsx` drew `READING_CARDS` — NINE promises in a grid — and
// `ReadingRibbon.tsx` rotated the same roster one at a time above the room title. Her verdict is
// about both: a roster is a crowd whichever way it is animated. The plural name is DELETED with the
// plural surface rather than left on a file that now holds one door (R165: a module named after a
// thing it no longer holds is a stale receipt, which is why `FloatingCloset.tsx` was renamed).
//
// >>> THE TAP NAVIGATES, AND THAT IS HER *"the taps do nothing"* REPAIRED. <<< The retired doors ran
// `onOpen(reading)` and moved nobody: `openMiniReading` flags a request and dispatches an event whose
// only listener is on the ASTROLOGY page, so on My Room it announced into an empty room and the
// deadline dropped it. Both halves are done here, in that order, because the navigation REMOUNTS the
// target and an event dispatched after it would fire before its listener exists.
//
// >>> IT DRAWS FOR A PAYING MEMBER AND FOR ONE WHO HAS NOT PAID, WHICH IS THE COLLAPSE HER CLAUSE
// ASKS FOR. <<< The two retired surfaces split on payment and this one does not: *"taps land true
// (the popup-to-membership-page flow for unpaid, the reading for paid)"*. So there is no `isMember`
// prop at all — a component that could not ask the question cannot answer it wrongly — and the gate
// is FREE-1's, at the generation moment, where `/api/astrology/mini-report` answers 402 into T8-3's
// interceptor and her purple box carries the way to the membership page.
//
// HOOKLESS ON PURPOSE, so `scripts/room-origin-door.mjs` CALLS it and reads the tree back in every
// state rather than grepping for it (R7/R12), and so her CLEANLINESS LAW's geometry pass has
// something to measure.
import { originDoor, roomDoorState, openMiniReading, MINI_READING_PAGE } from "../roomOrigin.js";
// `import type` only, which is what keeps this component loadable by a `.mjs` gate through the
// bundling loader while still being honest about what `goTo` accepts (R5/R6's entry requirement).
import type { Page } from "../lib/pages";

export function MyRoomReadingDoor({
  known,
  origin,
  heading,
  goTo,
  onOpen = openMiniReading,
}: {
  /** L5.1's answer — has this app been TOLD who this member is yet. Never coerced (R53/R136/R137). */
  known: boolean;
  /** The reading she clicked to arrive, or "" for an organic signup. The law refuses anything else. */
  origin: string;
  heading: string;
  /** The navigation half. Required, because a door that flags a request and moves nobody is the
   *  defect this round is about, and a default here would let a call site rebuild it silently. */
  goTo: (page: Page) => void;
  /** Handed in so a gate CALLS the door and reads back WHICH reading it asked for, with no window
   *  and no browser (R46's locked-door shape). */
  onOpen?: (key: string) => void;
}) {
  // THREE STATES, and the law answers all three — `wait` and `none` both draw nothing, and they are
  // kept apart there rather than here because *we have not looked* and *she clicked nothing* have
  // different futures: only the first one can still become a door (R18/L5.1).
  if (roomDoorState({ known, origin }) !== "show") return null;
  const door = originDoor(origin);
  if (!door) return null;

  return (
    <section className="room-door" aria-label={heading} data-room-door={door.reading}>
      <h2 className="room-door__heading">{heading}</h2>
      <button
        type="button"
        className="room-door__door"
        data-reading-door={door.reading}
        onClick={() => {
          // ANNOUNCE, THEN NAVIGATE. The flag is what survives the remount; the event is what opens
          // it for a member already standing in the astrology room.
          onOpen(door.reading);
          goTo(MINI_READING_PAGE as Page);
        }}
      >
        {/* HER OWN CARD PROMISE, WORD FOR WORD OFF THE ROSTER — never a shortened restatement. The
            promise is what she clicked; a paraphrase in her room is a different promise. */}
        <span className="room-door__promise">{door.promise}</span>
      </button>
    </section>
  );
}
